import PageableBase from 'app/collections/pageable_base';
import { appUrl } from 'utils/wrappers';
import Batch from 'app/models/batch';

export default PageableBase.extend({
  model: Batch,
  key: 'batches',
  url: appUrl('batches'),
});



// WEBPACK FOOTER //
// ./app/collections/batches.js